import React, {Component} from "react";

import View               from "./View";

export default class FormContainer extends Component {
  render () {
    let {
      NotificationHistory
    } = this.props;

    let {
      formType
    } = NotificationHistory;

    switch (formType.toUpperCase()) {
      case "VIEW":
        return <View {...this.props}/>
        break;
      default:
      return "";
    }
  }

  componentWillUnmount () {
    let {
      actions
    } = this.props;

    actions.setValue(
      {
        selectedData: null,
        formType: "",
        formId: "",
        formTitle: ""
      }
    );
  }
}



// WEBPACK FOOTER //
// ./components/NotificationHistory/FormContainer/index.js